import React from 'react'
import BlogHeader from '../BlogHeader/BlogHeader'
import { Link, Outlet } from 'react-router-dom';
import { Footer } from '../../sections';
import { IoChatbubblesOutline } from "react-icons/io5";
import { FaFacebookF, FaInstagram  } from "react-icons/fa6";
import { useTranslation } from 'react-i18next';
import { RiUserSettingsLine } from "react-icons/ri";
import { MdOutlineArticle,MdOutlineAccountBalance , MdPersonAddAlt1   } from "react-icons/md";
import { GrAnalytics } from "react-icons/gr";







function Layout() {
      const { t, i18n } = useTranslation();
      const isLoggedIn = localStorage.getItem('isLoggedIn');
  
  function showContact() {
    let contactsItem = document.querySelectorAll('.contact');
    contactsItem.forEach((item) => {
      item.classList.toggle('show-contact');
      })
    let contactBtn = document.getElementById('contact-btn');
    contactBtn.classList.toggle('rotate-motion')
  }
  function showControler() {
    let controlsItem = document.querySelectorAll('.addBtn');
    controlsItem.forEach((item) => {
      item.classList.toggle('show-controler');
      })
    let contactBtn = document.getElementById('contact-btn');
    contactBtn.classList.toggle('rotate-motion')
  }

  return (
    <main>
        <BlogHeader />
        <Outlet />
        <Footer />
        {isLoggedIn && (
        <div className='adminBtn'>
          <button className='controlerBtn' onClick={showControler}><RiUserSettingsLine /></button>
          <div className="addBtn show-controler">
                        <Link to="/Create"  target='_top'><MdOutlineArticle /><span>{t('createPost0')}</span></Link>
                        <Link to="/createMember" target='_top'><MdPersonAddAlt1 /><span>{t('createPost4')}</span></Link>
                        <Link to="/dashboard" target='_top'><GrAnalytics /><span>{t('dashboard')}</span></Link>
            </div>
        </div>
        )}
         <a  href="https://api.whatsapp.com/send/?phone=%2B963930644449&text&type=phone_number&app_absent=0"  target="_blank" rel='noreferrer' className="whatsapp contact-item  contact"><i className="fa-brands fa-whatsapp whatsapp-icon"></i></a>
          <a  href="tel:+963930644449" className='call contact-item contact'><i className="fa-solid fa-phone call-icon"></i></a>
          <a  href="https://www.facebook.com/profile.php?id=61579797128484" target='_blanck' className='facebook contact-item contact'><FaFacebookF className='facebook-icon' /></a>
          <a  href="https://www.instagram.com/albarede_law/" target='_blanck' className='instagram contact-item contact'><FaInstagram  className='instagram-icon' /></a>
          <button id='contact-btn' className='contact_float' onClick={(showContact)}><IoChatbubblesOutline className='contact-icon' /></button>
    </main>
  )
}

export default Layout


